import { InsuranceCompanies } from "../../models/consignado/insurance-companies.model";
import { axiosConsignadoInstance } from "../axiosInstance";

export type InsuranceCompaniesProps = {
  page: number;
  pageSize: number;
}

export const getInsuranceCompanies = async ({
  page,
  pageSize,
}: InsuranceCompaniesProps): Promise<InsuranceCompanies[]> => {
  try {


    const response = await axiosConsignadoInstance.get<InsuranceCompanies[]>(`/api-consignado-trabalhador/v1/insurance-companies`, {
      params: {
        pagina: page,
        tamanhoPagina: pageSize,
      },
    });

    return response.data
  } catch (error) {
    console.error("Erro ao obter Propostas:", error);
    throw error;
  }
};